export default {
    en: {
        "中国": "China",
        "中国香港": "Hong Kong, China",
		"香港": "Hong Kong, China",
        "中国澳门": "Macau, China",
		"澳门": "Macau, China",
        "中国台湾": "Taiwan, China",
		"台湾": "Taiwan, China",
        "美国": "United States",
        "阿尔巴尼亚": "Albania",
        "阿尔及利亚": "Algeria",
        "阿富汗": "Afghanistan",
        "阿根廷": "Argentina",
        "阿拉伯联合酋长国": "United Arab Emirates",
        "阿鲁巴": "Aruba",
        "阿曼": "Oman",
        "阿塞拜疆": "Azerbaijan",
        "阿提瓜和巴布达": "Antigua and Barbuda",
        "埃及": "Egypt",
        "埃塞俄比亚": "Ethiopia",
        "爱尔兰": "Ireland",
        "爱沙尼亚": "Estonia",
        "安道尔": "Andorra",
        "安哥拉": "Angola",
        "安圭拉": "Anguilla",
        "奥地利": "Austria",
        "澳大利亚": "Australia",
        "巴巴多斯": "Barbados",
        "巴布亚新几内亚": "Papua New Guinea",
        "巴哈马": "Bahamas",
        "巴基斯坦": "Pakistan",
        "巴拉圭": "Paraguay",
        "巴林": "Bahrain",
        "巴拿马": "Panama",
        "巴西": "Brazil",
        "白俄罗斯": "Belarus",
        "百慕大": "Bermuda",
        "保加利亚": "Bulgaria",
        "北马里亚纳群岛": "Northern Mariana Islands",
        "贝宁": "Benin",
        "比利时": "Belgium",
        "冰岛": "Iceland",
        "波多黎各": "Puerto Rico",
        "波兰": "Poland",
        "波斯尼亚和黑塞哥维那": "Bosnia and Herzegovina",
        "玻利维亚": "Bolivia",
        "伯利兹": "Belize",
        "博茨瓦纳": "Botswana",
        "不丹": "Bhutan",
        "布基纳法索": "Burkina Faso",
        "布隆迪": "Burundi",
        "朝鲜": "North Korea",
        "赤道几内亚": "Equatorial Guinea",
        "丹麦": "Denmark",
        "德国": "Germany",
        "东帝汶": "Timor-Leste",
        "多哥": "Togo",
        "多米尼克": "Dominica",
        "多尼米加共和国": "Dominican Republic",
        "俄罗斯": "Russia",
        "厄瓜多尔": "Ecuador",
        "厄立特里亚": "Eritrea",
        "法国": "France",
        "法罗群岛": "Faroe Islands",
        "法属波利尼西亚": "French Polynesia",
        "法属圣马丁": "Saint Martin",
        "梵蒂冈": "Vatican",
        "菲律宾": "Philippines",
        "斐济": "Fiji",
        "芬兰": "Finland",
        "佛得角": "Cape Verde",
        "福克兰群岛": "Falkland Islands",
        "冈比亚": "Gambia",
        "刚果（布）": "Congo-Brazzaville",
        "刚果（金）": "Congo-kinshasa",
        "哥伦比亚": "Colombia",
        "哥斯达黎加": "Costa Rica",
        "格林纳达": "Grenada",
        "格陵兰": "Greenland",
        "格鲁吉亚": "Georgia",
        "古巴": "Cuba",
        "关岛": "Guam",
        "圭亚那": "Guyana",
        "哈萨克斯坦": "Kazakhstan",
        "海地": "Haiti",
        "韩国": "South Korea",
        "荷兰": "Netherlands",
        "黑山": "Montenegro",
        "洪都拉斯": "Honduras",
        "基里巴斯": "Kiribati",
        "吉布提": "Djibouti",
        "吉尔吉斯斯坦": "Kyrgyzstan",
        "几内亚": "Guinea",
        "几内亚比绍": "Guinea-Bissau",
        "加拿大": "Canada",
        "加纳": "Ghana",
        "加蓬": "Gabon",
        "柬埔寨": "Cambodia",
        "捷克共和国": "Czech Republic",
        "津巴布韦": "Zimbabwe",
        "喀麦隆": "Cameroon",
        "卡塔尔": "Qatar",
        "开曼群岛": "Cayman Islands",
        "科科斯（基林）群岛": "Cocos (Keeling) Islands",
        "科摩罗": "Comoros",
        "科特迪瓦": "Côte d'Ivoire",
        "科威特": "Kuwait",
        "克罗地亚": "Croatia",
        "肯尼亚": "Kenya",
        "库克群岛": "Cook Islands",
        "拉脱维亚": "Latvia",
        "莱索托": "Lesotho",
        "老挝": "Laos",
        "黎巴嫩": "Lebanon",
        "立陶宛": "Lithuania",
        "利比里亚": "Liberia",
        "利比亚": "Libya",
        "列支敦士登": "Liechtenstein",
        "卢森堡": "Luxembourg",
        "卢旺达": "Rwanda",
        "罗马尼亚": "Romania",
        "马达加斯加": "Madagascar",
        "马尔代夫": "Maldives",
        "马耳他": "Malta",
        "马拉维": "Malawi",
        "马来西亚": "Malaysia",
        "马里": "Mali",
        "马其顿": "Macedonia",
        "马绍尔群岛": "Marshall Islands",
        "马约特": "Mayotte",
        "曼岛": "Isle of Man",
        "毛里求斯": "Mauritius",
        "毛里塔尼亚": "Mauritania",
        "美属萨摩亚": "American Samoa",
        "美属维京群岛": "U.S. Virgin Islands",
        "蒙古": "Mongolia",
        "蒙特塞拉特": "Montserrat",
        "孟加拉国": "Bangladesh",
        "秘鲁": "Peru",
        "密克罗尼西亚": "Micronesia",
        "缅甸": "Myanmar（Burma）",
        "摩尔多瓦": "Moldova",
        "摩洛哥": "Morocco",
        "摩纳哥": "Monaco",
        "莫桑比克": "Mozambique",
        "墨西哥": "Mexico",
        "纳米比亚": "Namibia",
        "南非": "South Africa",
        "南极洲": "Antarctica",
        "瑙鲁": "Nauru",
        "尼泊尔": "Nepal",
        "尼加拉瓜": "Nicaragua",
        "尼日尔": "Niger",
        "尼日利亚": "Nigeria",
        "纽埃": "Niue",
        "挪威": "Norway",
        "帕劳": "Palau",
        "皮特凯恩群岛": "Pitcairn Islands",
        "葡萄牙": "Portugal",
        "日本": "Japan",
        "瑞典": "Sweden",
        "瑞士": "Switzerland",
        "萨尔瓦多": "El Salvador",
        "萨摩亚": "Samoa",
        "塞尔维亚": "Serbia",
        "塞拉利昂": "Sierra Leone",
        "塞内加尔": "Senegal",
        "塞浦路斯": "Cyprus",
        "塞舌尔": "Seychelles",
        "沙特阿拉伯": "Saudi Arabia",
        "圣巴泰勒米": "Saint Barthélemy",
        "圣诞岛": "Christmas Island",
        "圣多美和普林西比": "Sao Tome and Principe",
        "圣赫勒拿": "St. Helena",
        "圣基茨和尼维斯": "St. Kitts and Nevis",
        "圣卢西亚": "St. Lucia",
        "圣马力诺": "San Marino",
        "圣皮埃尔和密克隆群岛": "St. Pierre and Miquelon Islands",
        "圣文森特和格林纳丁斯": "Saint Vincent and the Grenadines",
        "斯里兰卡": "Sri Lanka",
        "斯洛伐克": "Slovakia",
        "斯洛文尼亚": "Slovenia",
        "斯威士兰": "Swaziland",
        "苏丹": "Sudan",
        "苏里南": "Suriname",
        "所罗门群岛": "Solomon Islands",
        "索马里": "Somalia",
        "塔吉克斯坦": "Tajikistan",
        "泰国": "Thailand",
        "坦桑尼亚": "Tanzania",
        "汤加": "Tonga",
        "特克斯和凯科斯群岛": "Turks and Caicos Islands",
        "特立尼达和多巴哥": "Trinidad and Tobago",
        "突尼斯": "Tunisia",
        "图瓦卢": "Tuvalu",
        "土耳其": "Turkey",
        "土库曼斯坦": "Turkmenistan",
        "托克劳": "Tokelau",
        "瓦利斯和富图纳": "Wallis and Futuna",
        "瓦努阿图": "Vanuatu",
        "危地马拉": "Guatemala",
        "委内瑞拉": "Venezuela",
        "文莱": "Brunei",
        "乌干达": "Uganda",
        "乌克兰": "Ukraine",
        "乌拉圭": "Uruguay",
        "乌兹别克斯坦": "Uzbekistan",
        "西班牙": "Spain",
        "希腊": "Greece",
        "新加坡": "Singapore",
        "新喀里多尼亚": "New Caledonia",
        "新西兰": "New Zealand",
        "匈牙利": "Hungary",
        "叙利亚": "Syria",
        "牙买加": "Jamaica",
        "亚美尼亚": "Armenia",
        "也门": "Yemen",
        "伊拉克": "Iraq",
        "伊朗": "Iran",
        "以色列": "Israel",
        "意大利": "Italy",
        "印度": "India",
        "印度尼西亚": "Indonesia",
        "英国": "United Kingdom",
        "英属维京群岛": "British Virgin Islands",
        "约旦": "Jordan",
        "越南": "Vietnam",
        "赞比亚": "Zambia",
        "乍得": "Chad",
        "直布罗陀": "Gibraltar",
        "智利": "Chile",
        "中非共和国": "Central African Republic",
    }
}